import { useDependentStore } from "./useDependentStore";

export const useHasDependents = () => {
  const { dependentStore: {spouse, dependents} } = useDependentStore();

  const hasSpouse = !!spouse;
  const hasDependents = dependents.length > 0;
  const hasDependentsOrSpouse = hasDependents || hasSpouse
  const hasFamily = hasDependents && hasSpouse;

  return { hasDependentsOrSpouse, hasSpouse, hasDependents, hasFamily };
};
